import {
	Box,
	Button,
	Flex,
	Heading,
	SimpleGrid,
	Stack,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { fadeUp } from 'utils/animation';
import { sections } from 'views/client/education/variable/sections';

const animation = `${fadeUp} 0.6s ease-out forwards`;

export default function Education() {
	const textColor = useColorModeValue('gray.900', 'gray.100');
	const cardBg = useColorModeValue('gray.100', 'gray.500');
	const navigate = useNavigate();
	const location = useLocation();
	let isClient = false;
	if (location.pathname.includes('client')) isClient = true;

	return (
		<Flex
			maxW={isClient ? '' : '80%'}
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Heading
				mb='20px'
				color={textColor}
				fontSize='2xl'
				ms='24px'
				fontWeight='700'
			>
				Aprende con Bumbei
			</Heading>

			<SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
				{sections.map((section, idx) => (
					<Box
						key={idx}
						borderRadius='xl'
						animation={animation}
						animationDelay={`${idx * 0.15}s`}
						opacity={0}
						boxShadow='md'
						p={6}
						transition='all 0.2s'
						display='flex'
						flexDirection='column'
						justifyContent='space-between'
						backgroundColor={cardBg}
						_hover={{ boxShadow: 'lg', transform: 'translateY(-4px)' }}
					>
						<Stack spacing={4}>
							<Text fontSize='4xl'>{section.emoji}</Text>
							<Heading size='md'>{section.title}</Heading>
							<Text>{section.description}</Text>
						</Stack>
						<Button
							as='a'
							onClick={() => navigate(section.link)}
							variant='brand'
							width='fit-content'
							mt={4}
						>
							Leer más
						</Button>
					</Box>
				))}
			</SimpleGrid>
		</Flex>
	);
}
